import { useCallback } from 'react'
import RichTextEditor from 'reactjs-tiptap-editor'
import extensions from './extensions'

interface EditorProps {
  content: string;
  setContent: (content: string) => void;
}

function Editor({ content, setContent }: EditorProps) {
  const onValueChange = useCallback((value: string) => {
    setContent(value);
  }, [setContent])

  return (
    <div className="form-control p-0 overflow-hidden editor-wrapper">
      <RichTextEditor
        output="html"
        content={content}
        onChangeContent={onValueChange}
        extensions={extensions}
        dark={false}
        bubbleMenu={{ render: (_, dom) => dom }}
      />
    </div>
  )
}

export default Editor
